import { getTriggers } from '../helpers/triggers';
import { $$ } from '../helpers/shortcuts';

const scrollThreshold = 140;

function checkButtonVisibility() {
  if (document.body.hasAttribute('data-scroll-disabled')) return;
  const $buttons = $$('.scrolltotopbutton');
  if (window.scrollY >= scrollThreshold) {
    $buttons.forEach(($button) =>
      $button.classList.add('scrolltotopbutton-isvisible'),
    );
  } else {
    $buttons.forEach(($button) =>
      $button.classList.remove('scrolltotopbutton-isvisible'),
    );
  }
}

function initializeScrollToTopButton() {
  getTriggers('scrolltotop').forEach(($el) => {
    $el.addEventListener('click', () =>
      window.scrollTo({ top: 0, behavior: 'smooth' }),
    );
  });

  window.addEventListener('scroll', checkButtonVisibility);
  window.addEventListener('resize', checkButtonVisibility);
}

export { initializeScrollToTopButton };
